module.exports = __webpack_public_path__ + "static/media/lemon-slice-1.a6686faf.png";